import { PageLinkButton } from "@chef/smart-components";
import { useEffectOnce } from "@chef/hooks";
import { useTrack } from "@chef/state-management/hooks";

import { LINK, SHARED_BRAND } from "../utils";
import { useTrackingData } from "../hooks/useTrackingData";

export const MyAccountStartPage = () => {
  const track = useTrack();

  const trackingData = useTrackingData();

  useEffectOnce(() => {
    if (trackingData) {
      track("viewAccount", {
        affiliation: "Frontend process",
        payment_method: trackingData.payment_method,
        products: trackingData.products,
        status: trackingData.status,
        timeblock_day: trackingData.timeblock_day,
        timeblock_id: trackingData.timeblock_id,
        timeblock_interval: trackingData.timeblock_interval,
        url: window.location.href,
        week_type_id: trackingData.week_type_id,
        week_type_name: trackingData.week_type_name,
      });
    }
  }, trackingData !== undefined);

  return (
    <>
      <div className="hidden md:block col-span-full md:col-start-2 xl:col-start-4">
        <h1>
          <strong>{SHARED_BRAND.MY_ACCOUNT_TITLE}</strong>
        </h1>
      </div>

      <ul
        className="col-span-6 md:col-start-2 xl:col-start-4"
        id="my-account-links"
      >
        {SHARED_BRAND.LINKS.map((l: LINK) => (
          <PageLinkButton key={l.page} {...l} id={l.page} Icon={<l.Icon />} />
        ))}
      </ul>
    </>
  );
};
